import {
  IconCalendarCog,
  IconCalendarWeek,
  IconChecklist,
  IconCopy as IconCopyTabler,
  IconCircleDottedLetterF,
  IconDownload as IconDownloadTabler,
  IconHome,
  IconInfoCircle,
  IconListCheck,
  IconMail,
  IconMailCode,
  IconMailCog,
  IconArrowMoveUp,
  IconPassword as IconPaswordTabler,
  IconPencil,
  IconPlus,
  IconHelpCircle,
  IconSettings,
  IconTrash,
  IconUpload as IconUploadTabler,
  IconUser as IconUserTabler,
  IconUsers,
  IconX,
  IconProps,
  IconArrowMoveDown,
  IconCopyPlus,
  IconMailFast,
  IconRefresh as IconRefreshTabler,
} from "@tabler/icons-react";

const SIZE = 16;
const STROKE = 1.5;

export const IconHelp = (props: IconProps) => (
  <IconHelpCircle size={SIZE} stroke={STROKE} {...props} />
);
export const IconEdit = (props: IconProps) => (
  <IconPencil size={SIZE} stroke={STROKE} {...props} />
);
export const IconClone = (props: IconProps) => (
  <IconCopyPlus size={SIZE} stroke={STROKE} {...props} />
);
export const IconCopy = (props: IconProps) => (
  <IconCopyTabler size={SIZE} stroke={STROKE} {...props} />
);
export const IconCustomField = (props: IconProps) => (
  <IconCircleDottedLetterF size={SIZE} stroke={STROKE} {...props} />
);
export const IconEventsAsGuest = (props: IconProps) => (
  <IconCalendarWeek size={SIZE} stroke={STROKE} {...props} />
);
export const IconEventsAsHost = (props: IconProps) => (
  <IconCalendarWeek size={SIZE} stroke={STROKE} {...props} />
);
export const IconEventHome = (props: IconProps) => (
  <IconHome size={SIZE} stroke={STROKE} {...props} />
);
export const IconConfigureEvent = (props: IconProps) => (
  <IconCalendarCog size={SIZE} stroke={STROKE} {...props} />
);
export const IconActivities = (props: IconProps) => (
  <IconListCheck size={SIZE} stroke={STROKE} {...props} />
);
export const IconActivity = (props: IconProps) => (
  <IconChecklist size={SIZE} stroke={STROKE} {...props} />
);
export const IconEmail = (props: IconProps) => (
  <IconMail size={SIZE} stroke={STROKE} {...props} />
);
export const IconEmailTemplate = (props: IconProps) => (
  <IconMailCode size={SIZE} stroke={STROKE} {...props} />
);
export const IconEmailConfiguration = (props: IconProps) => (
  <IconMailCog size={SIZE} stroke={STROKE} {...props} />
);
export const IconGuests = (props: IconProps) => (
  <IconUsers size={SIZE} stroke={STROKE} {...props} />
);
export const IconMoveDown = (props: IconProps) => (
  <IconArrowMoveDown size={SIZE} stroke={STROKE} {...props} />
);
export const IconMoveUp = (props: IconProps) => (
  <IconArrowMoveUp size={SIZE} stroke={STROKE} {...props} />
);
export const IconRsvp = (props: IconProps) => (
  <IconUserTabler size={SIZE} stroke={STROKE} {...props} />
);
export const IconUser = (props: IconProps) => (
  <IconUserTabler size={SIZE} stroke={STROKE} {...props} />
);
export const IconDelete = (props: IconProps) => (
  <IconTrash size={SIZE} stroke={STROKE} {...props} />
);
export const IconDownload = (props: IconProps) => (
  <IconDownloadTabler size={SIZE} stroke={STROKE} {...props} />
);
export const IconUpload = (props: IconProps) => (
  <IconUploadTabler size={SIZE} stroke={STROKE} {...props} />
);
export const IconAddNew = (props: IconProps) => (
  <IconPlus size={SIZE} stroke={STROKE} {...props} />
);
export const IconPassword = (props: IconProps) => (
  <IconPaswordTabler size={SIZE} stroke={STROKE} {...props} />
);
export const IconUserSettings = (props: IconProps) => (
  <IconSettings size={SIZE} stroke={STROKE} {...props} />
);
export const IconInfo = (props: IconProps) => (
  <IconInfoCircle size={SIZE} stroke={STROKE} {...props} />
);
export const IconClearField = (props: IconProps) => (
  <IconX size={SIZE} stroke={STROKE} {...props} />
);
export const IconSendMessage = (props: IconProps) => (
  <IconMailFast size={SIZE} stroke={STROKE} {...props} />
);
export const IconRefresh = (props: IconProps) => (
  <IconRefreshTabler size={SIZE} stroke={STROKE} {...props} />
);
